import './index.scss'
import DigitalAssetsHead from './modules/DigitalAssetsHead'
import DigitalAssetsContent from './modules/DigitalAssetsContent'
import DigitalAssetsFoot from './modules/DigitalAssetsFoot'


const Home = () => {

 return (
  <div className={`digital-assets`}>
    <DigitalAssetsHead />

    <DigitalAssetsContent />

    <DigitalAssetsFoot />

  </div>
 )
}

export default Home